import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../ApiConfig';
import { getSecureToken } from '../ApisService/apiService';

const SubscriptionPopup = () => {
  const [status, setStatus] = useState(null);
  const [remainingDays, setRemainingDays] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      try {
        const email = localStorage.getItem("userEmail");
        if (!email) {
          setStatus("error");
          return;
        }

                 const { secrettoken, ts } = await getSecureToken();

        const response = await axios.get(`${API_BASE_URL}payment/check_plan.php`, {
          params: { email },
          headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    },
          withCredentials: true,
        });

        const data = response.data;

        if (data.status === "active") {
          const formattedDate = new Date(data.expiry_date).toISOString().split("T")[0];
          setExpiryDate(formattedDate);
          setRemainingDays(data.remaining_days);
          setStatus("active");

          if (data.remaining_days <= 5) {
            setShowModal(true);
          }
        } else {
          setStatus("expired");
          setShowModal(true);
        }

      } catch (error) {
        console.error("Error fetching subscription status:", error);
        setStatus("error");
      }
    };

    fetchSubscriptionStatus();
  }, []);

  const closeModal = () => setShowModal(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal]);

  return (
    <>
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 1050,
            overflowY: 'auto'
          }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg" >
            <div
              className="modal-content shadow-lg rounded-4 p-3 p-sm-4 position-relative"
              ref={modalRef}
              style={{ backgroundColor: 'var(--body-bg)' }}
            >
              {/* Close Button */}
              <button
                type="button"
                className="btn-close position-absolute top-0 end-0 m-3"
                aria-label="Close"
                onClick={closeModal}
              ></button>

              {/* Header */}
              <div className="modal-header border-0 pb-0 justify-content-center">
                <h2 className="modal-title text-danger text-center fw-bold">
                  ⚠ Subscription Alert
                </h2>
              </div>

              {/* Body */}
              <div className="modal-body">
                <p className={`fw-bold fs-5 text-center ${status === 'expired' ? 'text-danger' : 'text-warning'}`}>
                  {status === "expired"
                    ? "Your subscription has expired!"
                    : `Your subscription will expire in ${remainingDays} day${remainingDays > 1 ? 's' : ''} (on ${expiryDate})`}
                </p>

                <div className="mt-4 text-center">
                  <h6 className="fw-semibold mb-3"  style={{ color: 'var(--tittle-text)' }}>Upgrade Your Plan:</h6>
                  <img
                    src="/images/Student stress-rafiki.svg"
                    alt="Upgrade Illustration"
                    className="img-fluid"
                    style={{ maxWidth: '300px', width: '80%', height: 'auto' }}
                  />
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer border-0 justify-content-center">
                <button className="btn btn-outline-secondary me-2" onClick={closeModal}>
                  Remind Me Later
                </button>

              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionPopup;
